import frame2 from "../images/frame2.png";
import frame1 from "../images/frame1.png";
function LoginImageBanner() {
  return (
    <div className="login-bg-logo text-white d-none d-md-block d-md-flex col-md-6 justify-content-md-center align-items-md-center">
      <div className="container mt-7 p-7 text-start">
        <div className="mb-9">
          <h2>Simplify Your Finances With Kegow</h2>
          <p>
            Seamless payments, smart budgeting, and stress-free money
            management-all in one app.
          </p>
        </div>

        <ul className="d-flex flex-column list-unstyled mb-8 align-items-start ">
          <li className="d-flex gap-4 flex-row align-items-start ">
            <img className="frame-img" src={frame2} alt="card-icon" />
            <p>
              <span className="fs-3 fw-700">Seamless Payments</span>
              <br />
              <small>Pay anyone, anytime, anywhere</small>
            </p>
          </li>

          <li className="d-flex gap-4 flex-row align-items-start ">
            <img className="frame-img" src={frame1} alt="secure-icon" />
            <p>
              <span className="fs-3 fw-700">Secure Transactions</span>
              <br />
              <small>Security guaranteed with zero worries</small>
            </p>
          </li>
        </ul>

        <div className="text-center d-flex gap-7 justify-content-start ">
          <aside>
            <h2 className="mb-0">50K+</h2>
            <small>Subscribers</small>
          </aside>
          <aside>
            <h2 className="mb-0">100%</h2>
            <small>Secure Transactions</small>
          </aside>
        </div>
      </div>
    </div>
  );
}
export default LoginImageBanner;
